import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry, Sentry } from "./lib/sentry";
import App from "./App";
import "./index.css";

initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Une erreur est survenue. Rechargez la page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
